import { createContext } from 'react';
import { observable } from 'mobx';

// This is to ensure that whenever we route back to the dataset, the appropriate categories are still open
// (regardless of the dataset being unmounted)
export default createContext(observable.map<string, string>());